import * as THREE from 'three';
import { Scene, OrthographicCamera, WebGLRenderer, Vector3, MeshBasicMaterial, SphereGeometry, TorusGeometry } from 'three';
import bgVert from "../glsl/bg.vert";
import bgFrag1 from "../glsl/flow.frag";
//import snoise from "../glsl/simplexNoise.frag";
import { RttSceneBase } from './RttSceneBase';
import { Params } from '../data/Params';

export class RttScene extends RttSceneBase{

    scene   :Scene;
    camera  :OrthographicCamera;
    renderTarget    :THREE.WebGLRenderTarget;

    sphere: THREE.Mesh;
    speed: THREE.Vector3;
    //https://www.pentacreation.com/blog/2021/05/210504.html

    constructor(){
        super();

        let colorShift = new Vector3(
                1.006+0.006*Params.random(),
                1.006+0.006*Params.random(),
                1.006+0.006*Params.random()
        );
        
        const planeGeometry = new THREE.PlaneGeometry(2,2,1,1);
        this.material = 
            new THREE.ShaderMaterial({
                uniforms: {
                    time: {value: 1.0},
                    tex1:{value:null},
                    flowMap:{value:null},
                    colorShift:{
                        value: colorShift
                    },
                    //dLight:{value:Params.dLight.position},
                    resolution: {value: new THREE.Vector2(
                        1024,1024                 
                    )}
                },
                vertexShader:   bgVert,
                fragmentShader: bgFrag1
            });

        const plane = new THREE.Mesh(planeGeometry, this.material);
        this.scene.add(plane);

        //出力チェック用
        const plane2 = new THREE.Mesh(planeGeometry,new MeshBasicMaterial({
            map:this.renderTarget.texture
        }));
        plane2.scale.set(50,50,50)
        this.add(plane2);        
    }

    update(renderer:WebGLRenderer){
        
        super.update(renderer);
         
    }

}